module.exports = __webpack_public_path__ + "img/wish.41894203.png";